import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./Button.css";
function Button(props) {
    var _a, _b, _c;
    var checkButtonSize = (_a = props.button_size) !== null && _a !== void 0 ? _a : "";
    var checkTextColor = (_b = props.text_color) !== null && _b !== void 0 ? _b : "text-dark";
    var checkBgColor = (_c = props.bg_color) !== null && _c !== void 0 ? _c : "text-white";
    return (
    // TODO: if `react-router-dom` is installed, insert `Link` tag.
    _jsx("div", { children: _jsx("input", { className: "button-style " + checkButtonSize + " " + checkTextColor + " " + checkBgColor, type: "submit", value: props.title }, void 0) }, void 0));
}
export default Button;



//////////////////
// WEBPACK FOOTER
// ./src/components/Button.tsx
// module id = 18
// module chunks = 0